<template>
  <div class="app-banner-page-view">
    <div class="swiper-container">
      <div class="swiper-wrapper">
        <div class="swiper-slide"  v-for="(item,index) in bannerList">
          <img class="bannerImg" :src="item.imgUrl" alt="" />
        </div>
      </div>
      <div class="swiper-pagination"></div>
    </div>
  </div>
</template>
<script>
  import Swiper from 'swiper';
  import 'swiper/dist/css/swiper.min.css';
  export default{
    name: 'BannerSwiper',
    data(){
      return {
      };
    },
    props: {
      bannerList: Array
    },
    computed: {
    },
    components: {},
    methods: {
      bannerSwiper: function () {
        this.circulationSwiper = new Swiper('.swiper-container', {
          autoplay: 3000,
          // 分页器
          pagination: '.swiper-pagination',
          paginationClickable: true,
          observer:true,
          observeParents:true,
          loop:true,
          autoplayDisableOnInteraction : false,
          onClick: swiperbanner => {
            let index = swiperbanner.activeIndex;
            if (index === 0) {
              this.$emit(
                'actionClickBanner',
                this.bannerList[this.bannerList.length - 1],
                this.bannerList.length - 1
              );
            } else if (index === this.bannerList.length + 1) {
              this.$emit('actionClickBanner', this.bannerList[0], 0);
            } else {
              this.$emit('actionClickBanner', this.bannerList[index - 1], index - 1);
            }
          }
        });
      }
    },
    created: function () {
    },
    mounted: function () {
      this.bannerSwiper();
    }
  };
</script>
<style lang="scss" rel="stylesheet/scss">
  .app-banner-page-view{
    .swiper-container {
      width: 100%;
      .swiper-wrapper {
        .bannerImg {
          width:100%;
          max-height:350px;
        }
      }

      .swiper-pagination {
        .swiper-pagination-bullet {
          width:0.2rem;
          height:0.2rem;
          background: #aaacbc;
          opacity: 1;
          margin-left:0.2rem;
        }
        .swiper-pagination-bullet-active {
          width:0.2rem;
          height:0.2rem;
          background: #ffb52f;
          opacity: 1;
        }
      }
    }
  }

</style>
